// extracted by mini-css-extract-plugin
export default {"employees_buttons":"workersList_employees_buttons__sKYHS","copy_title":"workersList_copy_title__xzdPM","copy_block":"workersList_copy_block__2UvmT"};